import(/* webpackMode: "eager" */ "/app/app/(protected)/parcels/layout.tsx");
